











































import { Component, Mixins, Emit, } from "vue-property-decorator";
import { ModelEditableMixin, DialogMixin } from "../../../../components/system";
import {
  IAiKeywordSyntax,
  IAiIfSyntax,
  IAiPromptSyntax,
} from "../../../../domain/externalSystem";
import {
  AiSyntaxKeywordEditor,
  AiSyntaxIfEditor,
  AiSyntaxPromptEditor,
} from "./contents";

@Component({
  components: {
    KeywordEditor: AiSyntaxKeywordEditor,
    IfEditor: AiSyntaxIfEditor,
    PromptEditor: AiSyntaxPromptEditor,
  }
})
export default class AiSyntaxDialog extends Mixins(ModelEditableMixin, DialogMixin) {
  @Emit("closed")
  closed(): void {}

  data(): any {
    return {
      isConfirmed: false,
      selectedComponent: "",
      syntaxes: null,
      defaultKeyword: "",
      editSyntax: null,
    };
  }
  isConfirmed: boolean;
  selectedComponent: string;
  syntaxes: { [key in string]: IAiKeywordSyntax | IAiIfSyntax | IAiPromptSyntax };
  defaultKeyword: string;
  editSyntax: (defaultKeyword: string) => Promise<string>;

  get components(): { [key in string]: string } {
    return {
      keywordEditor: "keyword-editor",
      ifEditor: "if-editor",
      promptEditor: "prompt-editor",
    };
  }

  createDefaultSyntaxes(): { [key in string]: IAiKeywordSyntax | IAiIfSyntax | IAiPromptSyntax } {
    return {
      [this.components.keywordEditor]: this.createDefaultKeywordSyntax(),
      [this.components.ifEditor]: this.createDefaultIfSyntax(),
      [this.components.promptEditor]: this.createDefaultPromptSyntax(),
    };
  }

  createDefaultKeywordSyntax(): IAiKeywordSyntax {
    return {
      isValid: !!this.defaultKeyword,
      value: this.defaultKeyword ? "{ " + this.defaultKeyword + " }" : "{ }",
      keyword: this.defaultKeyword,
      shouldRemoveLineBreak: true,
      isSupplementEnable: false,
      supplement: "",
    };
  }

  createDefaultIfSyntax(): IAiIfSyntax {
    return {
      isValid: false,
      value: "{ if {  } ? {  } }",
      condition: "",
      template: "",
      isElseEnable: false,
      elseTemplate: "",
    };
  }

  createDefaultPromptSyntax(): IAiPromptSyntax {
    return {
      isValid: false,
      value: "{ prompt ? {  } }",
      prompt: "",
      filter: "",
      isFilterEnable: false,
    };
  }

  get syntax(): IAiKeywordSyntax | IAiIfSyntax | IAiPromptSyntax {
    return this.syntaxes
      ? this.syntaxes[this.selectedComponent]
      : null;
  }

  set syntax(value: IAiKeywordSyntax | IAiIfSyntax | IAiPromptSyntax) {
    this.syntaxes[this.selectedComponent] = value;
  }

  get syntaxValue(): string {
    return this.syntax
      ? this.syntax.value
      : "";
  }

  get isSyntaxValid(): boolean {
    return this.syntax && this.syntax.isValid;
  }

  selectComponent(key: string): void {
    this.selectedComponent = key;
  }

  isSelected(key: string): boolean {
    return this.selectedComponent === key;
  }

  async show(defaultKeyword: string, editSyntax: (defaultKeyword: string) => Promise<string>): Promise<string> {
    return this.showModal(async () => {
      this.isConfirmed = false;
      this.defaultKeyword = defaultKeyword;

      // 算出プロパティで持ってる既定値をスプレッド構文で展開して渡していた。
      // 対応当時のバージョンでは値渡しになっていて問題なかったが、
      // 北大バージョンでは参照渡しになっていて、既定値が書き換えられてしまう不具合が発生した。
      // 北大バージョンでも動作するよう、既定値は毎回インスタンスを生成するよう修正。
      // 参照渡しと値渡しの挙動差異が起きる真因については未特定。要調査。
      this.syntaxes = this.createDefaultSyntaxes();

      this.selectedComponent = this.components.keywordEditor;
      this.editSyntax = editSyntax;

      await this.waitHidden(true);
      this.closed();
      return this.isConfirmed
        ? this.syntaxValue
        : "";
    });
  }

  confirm(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
